@if (!deleted) {
  <div style="display:inline;"
    [ngClass]="{click: canBeEdited}"
    (click)="openModal()"
    >
    <material-order-position-status-label [status]="status">
    </material-order-position-status-label>
  </div>
}
@if (deleted) {
  <span class="label label-danger">Gelöscht</span>
}
